import React, { useEffect, useCallback } from "react";
import { useInView } from 'react-intersection-observer';

const YouTubeVideo = (props) => {
  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView && !window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      window.onYouTubeIframeAPIReady = loadVideo;
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    } else if (inView) {
      setTimeout(() => {
        loadVideo(); // iframe_api取得に時間がかかるため処理を遅らせる
      }, 100);
    }
  }, [inView]);

  const loadVideo = useCallback(() => {
    const { id, uniqId } = props;
    return new window.YT.Player(`youtube-player-${id}_${uniqId}`, {
      videoId: id,
      playerVars: {
        loop: 1,
        autoplay: 1,
        playsInline: 1,
        mute: 1,
        playlist: id,
        enablejsapi: 1,
        rel: 0,
        },
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerStateChange,
      },
    });
  }, [])

  const onPlayerReady = (e) => {
      e.target.mute();
      e.target.playVideo();
  };

  const onPlayerStateChange = (e) => {
    switch (e.data) {
      case window.YT.PlayerState.ENDED && inView:
        e.target.playVideo();
        break;
      case window.YT.PlayerState.PLAYING && !inView:
        e.target.stopVideo();
        break;
    }
  };

  return (
    <div ref={ref}>
      <div id={`youtube-player-${props.id}_${props.uniqId}`} style={props.style} />
    </div>
  )
}

export default YouTubeVideo;